import routerOptions0 from "/home/nodejs/kare-backoffice-v2/source/node_modules/.pnpm/nuxt@3.12.4_@types+node@20.14.15_eslint@8.57.1_typescript@5.8.3_vite@5.4.14_vue-tsc@3.0.3/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}